function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="210" height="250" viewBox="0 0 210 250" {...props}><g fill="none" fillRule="evenodd"><rect width="210" height="250" fill="#FFF" rx="4" /><path fill="#DFE2E5" d="M24 75h162v100H24z" /><path fill="#B1BCCA" d="M125.07 140H86.12c-1.07 0-1.44-.95-.82-1.83l11.26-16.16c.6-.88 1.72-1.03 2.48-.27l2.27 2.26c.75.76 1.92.69 2.6-.13l5.46-6.66c.68-.82 1.73-.78 2.33.1l14.2 20.85c.61.88.24 1.84-.83 1.84zm-2.56-20a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" /></g></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/block-image.svg